import { AUTO_SPIN_COUNT, AUTO_SPIN_COUNTS, AUTO_SPIN_INDEX, AUTO_SPIN_STATE } from '../../stateManagment/gameState';
import { spinResponseHelper } from './SpinResponseHelper';

class AutoSpinHelper {
  constructor() {
    this.autoSpinFlag = false;
    this.request = null;
  }

  checkAutoSpin(value) {
    return this.spinCountByControl && value;
  }

  get isAutoSpin() {
    return this.spinCountByControl && this.autoSpinFlag;
  }

  get spinCount() {
    return AUTO_SPIN_COUNT.getValue();
  }

  get autoSpinActive() {
    return AUTO_SPIN_STATE.getValue();
  }

  set spinCount(value) {
    if (!value) {
      this.stopAutoSpin();
    }
    AUTO_SPIN_COUNT.next(value);
  }

  get spinCountByControl() {
    return AUTO_SPIN_COUNTS.getValue()[AUTO_SPIN_INDEX.getValue()];
  }

  decrementAutoSpin() {
    if (this.spinCount !== Infinity) {
      this.spinCount = this.spinCount - 1;
    }
  }

  stopAutoSpin() {
    this.cancelDelay();
    this.autoSpinFlag = false;
    spinResponseHelper.stopSpin();
    AUTO_SPIN_STATE.next(false);
    AUTO_SPIN_COUNT.next(0);
    AUTO_SPIN_INDEX.next(0);
  }


  reset = () => {
    AUTO_SPIN_STATE.next(false);
    AUTO_SPIN_COUNT.next(0);
    AUTO_SPIN_INDEX.next(0);
  }

  pause() {
    this.cancelDelay();
    AUTO_SPIN_STATE.next(false);
  }

  resume() {
    this.autoSpinFlag = true;
    AUTO_SPIN_STATE.next(true);
  }

  startAutoSpin() {
    this.autoSpinFlag = true;
    AUTO_SPIN_STATE.next(true);
  }

  subscribeAutoSpinState(...args) {
    return AUTO_SPIN_STATE.subscribe(...args);
  }

  setDelay(req) {
    this.request = req;
  }

  cancelDelay() {
    if (this.request) {
      this.request.cancel();
      this.request = null;
    }
  }
}

export const autoSpinHelper = new AutoSpinHelper();
